import { Box } from '@palmetto/palmetto-components';

import { PartnerSignerRole } from 'types';

const SIGNER_ROLE_LABELS: Record<PartnerSignerRole, string> = {
  primaryApplicant: 'Primary applicant',
  coApplicant: 'Co-applicant',
  salesRep: 'Sales rep',
  licensedInstaller: 'Licensed installer',
};

const FALLBACK_SIGNER_LABEL = 'A signer';

const ContractSignerSigned = ({ event }: { event: { data?: { role?: string } } }) => {
  const role = event.data?.role;
  const roleLabel = role && role in SIGNER_ROLE_LABELS ? SIGNER_ROLE_LABELS[role as PartnerSignerRole] : undefined;
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        {roleLabel ?? FALLBACK_SIGNER_LABEL} signed the contract
      </Box>
    </Box>
  );
};

export default ContractSignerSigned;
